import { render, staticRenderFns } from "./Roullete.vue?vue&type=template&id=3c0f5532"
import script from "./Roullete.vue?vue&type=script&lang=js"
export * from "./Roullete.vue?vue&type=script&lang=js"
import style0 from "./Roullete.vue?vue&type=style&index=0&id=3c0f5532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports